import { render, staticRenderFns } from "./ArrivalOfGoods.vue?vue&type=template&id=13540b7e&scoped=true"
import script from "./ArrivalOfGoods.vue?vue&type=script&lang=js"
export * from "./ArrivalOfGoods.vue?vue&type=script&lang=js"
import style0 from "./ArrivalOfGoods.vue?vue&type=style&index=0&id=13540b7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13540b7e",
  null
  
)

export default component.exports